export const getISTDate = () => {
    // Robust YYYY-MM-DD generator independent of browser locale
    return new Intl.DateTimeFormat('en-CA', {
        timeZone: 'Asia/Kolkata',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
    }).format(new Date());
};

export const formatYYMMDD = (dateStr) => {
    // Converts 2026-03-12 to 260312
    return dateStr.replace(/-/g, "").slice(2);
};

export const getMasterKey = () => {
    const today = getISTDate(); // YYYY-MM-DD
    let hash = 0;
    for (let i = 0; i < today.length; i++) {
        hash = ((hash << 5) - hash) + today.charCodeAt(i);
        hash |= 0; // Convert to 32bit integer
    }
    const seed = Math.abs(hash);
    return String((seed % 9000) + 1000);
};

